import {decorate, injectable} from "inversify";
import {Action} from "@dp-instant/core";

export class AssetsPreloadActionHomeEvolution extends Action {
    async fontsPreload() {
        const rubikFont = new FontFace("Rubik", "url(../assets/fonts/Rubik-Bold.ttf)");
        rubikFont
            .load()
            .then(function (loaded_face) {
                document.fonts.add(loaded_face);
                document.body.style.fontFamily = '"Rubik"';
            })
            .catch(function (error) {
                console.log("Error loading font:", error);
            });
    }

    async preloadAndShareCodeAndLibs() {
        //preload
        await import("@pixi/math-extras");
        const {Application} = await import("../Application");
        const {Core} = await import("../ported/Base/Core");
        const {GameManager} = await import("../ported/Game/GameManager");
        const {gsap} = await import("gsap");
        const {PixiPlugin} = await import("gsap/PixiPlugin");

        //register
        gsap.registerPlugin(PixiPlugin);
        PIXI.utils.skipHello();

        //create app
        let app = Application.create();

        //share
        window.PIXI = PIXI; // XXX
        window.app = app; // XXX
        window.Core = Core; // XXX
        window.GameManager = GameManager; // XXX
        window.gsap = gsap; // XXX
        window.appPIXI = app; // XXX
    }

    async execute() {
        await this.preloadAndShareCodeAndLibs();
        await this.fontsPreload();
        await this.preloadGameAssets();
    }

    async preloadGameAssets() {
        console.log("Loading resources");
        await app.load();
        console.log("Application resources loaded");
    }
}

decorate(injectable(), AssetsPreloadActionHomeEvolution);
